module.exports = __webpack_public_path__ + "static/img/1.68028f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/1.jpg
// module id = qw56
// module chunks = 1